import * as React from 'react';
import s from './AppHeader.scss';
import { withInjectedRootStore, RootStore } from 'providers';
import { SwitchPlanNotificationBar } from 'components/SwitchPlanNotificationBar/SwitchPlanNotificationBar';
import classNames from 'classnames';
import { LoggedinHeaderSteps } from './LoggedinHeaderSteps';
import { Logo } from './Logo';
import { observer } from 'mobx-react';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { PlanType, Experiments, ProductFamily } from 'enums';

interface LoggedinHeaderProps extends InjectedExperimentsProps {
  changeStep(step: number): void;
  rootStore: RootStore;
}

const LoggedinHeaderComp: React.FunctionComponent<LoggedinHeaderProps> = ({
  changeStep,
  rootStore,
  experiments,
}) => {
  const {
    currentStep,
    isWizardHidden,
    planType,
    isSwitchPlan,
    appContext: { currentPlanDetails },
  } = rootStore.appStore;

  const isEnterpriseTabRendered =
    experiments.enabled(Experiments.AddEnterpriseTab) &&
    planType === PlanType.Enterprise;
  const shouldRenderSwitchPlanNotification = () =>
    currentPlanDetails &&
    isSwitchPlan &&
    currentPlanDetails?.productFamily !== ProductFamily.Enterprise;
  return (
    <>
      <header className={classNames(s.root)} data-hook='loggedin-header'>
        <div className={s.wixHeader}>
          <Logo />
          {!isWizardHidden && (
            <div
              data-testid='wizard'
              className={classNames(s.wizard, {
                [s.hidden]: isEnterpriseTabRendered,
              })}
            >
              <LoggedinHeaderSteps
                currentStep={currentStep}
                changeStep={changeStep}
              />
            </div>
          )}
        </div>
        {shouldRenderSwitchPlanNotification() && <SwitchPlanNotificationBar />}
      </header>
    </>
  );
};
export const LoggedinHeader = withInjectedRootStore(
  withExperiments(observer(LoggedinHeaderComp)),
);
